<template>
  <div
    class="vx-card alert-card"
    :class="{
      'normal-card': alertLevel === 'normal',
      'warning-card': alertLevel === 'warning',
      'caution-card': alertLevel === 'caution',
    }"
  >
    <div class="counter-container">
      <div
        class="number"
        :class="{
          'normal-counter': alertLevel === 'normal',
          'warning-counter': alertLevel === 'warning',
          'caution-counter': alertLevel === 'caution',
        }"
      >
        {{ counts }}
      </div>
      <div
        class="unit"
        :class="{
          'normal-unit': alertLevel === 'normal',
          'warning-unit': alertLevel === 'warning',
          'caution-unit': alertLevel === 'caution',
        }"
      >
        {{ unitText }}
      </div>
    </div>
    <div class="description-area">
      <div class="description">{{ title }}</div>
      <div class="info-icon-container">
        <vx-tooltip-with-slot-text position="bottom">
          <!-- ホバー時に表示するツールチップ -->
          <template v-slot:text>
            <tooltip-vessel-summary-alert
              v-if="isVesselAlert"
              :alert-info="alertInfo"
              :description="description"
            />
            <tooltip-crew-summary-alert
              v-else
              :alert-info="alertInfo"
              :description="description"
            />
          </template>
          <!-- ホバー対象 -->
          <template v-slot:inner>
            <span class="material-icons info-icon cursor-pointer">
              info
            </span>
          </template>
        </vx-tooltip-with-slot-text>
      </div>
    </div>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import { TooltipVesselSummaryAlert, TooltipCrewSummaryAlert } from "./tooltips";
export default {
  components: {
    VxTooltipWithSlotText,
    TooltipVesselSummaryAlert,
    TooltipCrewSummaryAlert,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    unitText: {
      type: String,
      required: true,
    },
    alertData: {
      type: Object,
      required: true,
    },
    alertSetting: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isVesselAlert: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    counts() {
      if (!this.alertData || !this.alertData.summary) return 0;
      return this.alertData.summary.counts;
    },
    message() {
      return this.alertInfo.message_summary;
    },
    alertInfo() {
      if (!this.alertData || !this.alertData.summary) return [];
      return this.alertData.summary.alert_info;
    },
    hasWarning() {
      if (!this.alertData || !this.alertData.summary) return false;
      return this.alertData.summary.alert_info.some(
        info => info.alert_type === "WARNING"
      );
    },
    hasCaution() {
      if (!this.alertData || !this.alertData.summary) return false;
      return this.alertData.summary.alert_info.some(
        info => info.alert_type === "CAUTION"
      );
    },
    alertLevel() {
      if (this.hasWarning) return "warning";
      if (this.hasCaution) return "caution";
      return "normal";
    },
    description() {
      const days = this.daysForDescription();
      const messages = {
        REPLACEMENT_CREW_NOT_ASSIGNED: `下船予定日が本日から${days}日以内で交代船員が未登録の場合にアラートを表示します。`,
        EMBARKATION_STANDBY:
          "乗船準備が未対応の船員がいる場合にアラートを表示します。",
        DISEMBARKATION_STANDBY:
          "下船準備が未対応の船員がいる場合にアラートを表示します",
        DAY_OFF_REQUEST_DUPLICATED: `本日から${days}日以内に休暇希望と乗船期間が重複している船員がいる場合にアラートを表示します。`,
      };

      return messages[this.alertSetting.kind] || "";
    },
  },
  methods: {
    daysForDescription() {
      if (this.hasCaution) {
        const days = this.alertSetting.caution_threshold_days;
        return days != null ? days : 0;
      }
      if (this.hasWarning) {
        const days = this.alertSetting.warning_threshold_days;
        return days != null ? days : 0;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-card {
  width: 140px;
  height: 60px;
  padding: 8px;

  .counter-container {
    display: flex;
    .number {
      font-size: 26px;
      font-weight: 600;
      line-height: 1;
    }

    .unit {
      font-size: 12px;
      font-weight: 600;
      margin-left: 2px;
      display: flex;
      align-items: flex-end;
    }
  }

  .description-area {
    position: relative;
    .description {
      font-size: 12px;
      font-weight: 600;
    }
    .info-icon-container {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .info-icon {
      font-size: 16px;
    }
  }

  &.warning-card {
    background-color: #fef3f2;
  }
  .warning-counter {
    color: #ff5252;
  }
  .warning-unit {
    color: #e02e22;
  }

  &.caution-card {
    background-color: #ffffe7;
  }
  .caution-counter {
    color: #ffd54f;
  }
  .caution-unit {
    color: #ffd400;
  }

  &.normal-card {
    background-color: #ffffff;
  }
  .normal-counter {
    color: #4fb0f7;
  }
  .normal-unit {
    color: #4fb0f7;
  }
}
</style>
